import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { FormComponent } from '../form/form.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CrudService } from '../crud.service';
import { UtilService } from '../util.service';
import { SharedEventService } from '../shared-event.service';
import { MessageService } from '../message.service';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.css']
})
export class CareerComponent implements OnInit {
  university_id: number;
  gridColumns: any[] = [];
  gridData: any[] = [];
  selectedRows: any[] = [];
  groups: any[] = [];
  showSpinner: boolean = false;
  form: FormGroup;
  statusView: string = 'grid';
  tituloDeLaVentana: string = 'Carreras';
  listaDeBotones: any[] = [
    { texto: 'Nueva Carrera +', onClick: () => this.createCareer() },
  ];

  constructor(
    private fb: FormBuilder,
    private crudService: CrudService,
    private dataService: DataService,
    private utilService: UtilService,
    private sharedEventService: SharedEventService,
    private messageService: MessageService
  ) { }

  formulario!: FormGroup;

  ngOnInit(): void {
    this.university_id = this.getUniversityId();
    this.loadTablaData();
    this.form = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      identifier: [''],
    });
    this.sharedEventService.selectionChanged.subscribe((data: any[]) => {
      this.changeSelectedRows(data);
    });
  }

  loadTablaData(): void {
    this.showSpinner = true;
    this.dataService.getTablaData({"university_id":this.university_id, "tablename":"career", "params":{} as any}).subscribe((data) => {
      console.log("data", data);
      const jsonString = JSON.stringify(data);
      const jsonObject = JSON.parse(jsonString);
      if (jsonObject.body.data == null) {
        jsonObject.body.data = [];
      }
      let cleanData = this.dataService.processGridData(jsonObject);
      this.gridColumns = this.processGridColumns(cleanData.columns);
      this.gridData = cleanData.data;
      this.showSpinner = false;      
    });
  }
  processGridColumns(columns: Text[]): any[] {
    return columns.map(texto => ({
      header: this.utilService.translateColumn(texto.toString()),
      field: texto,
      editable: false,
      type: 'text',
      hide: texto.toString() === 'id'? true: false,
    }));
  }

  onSubmit(nextClose: boolean): void {
    if (this.form.valid) {
      const datosCarrera = this.form.value;
      console.log('Datos de la Carrera:', datosCarrera);
      // Aquí puedes enviar los datos a tu servicio o hacer lo que necesites
        this.crudService.createRecord({"university_id": this.university_id, tablename: "career", "params": datosCarrera as any}).subscribe((data) => {
        console.log('Respuesta del servidor:', data);
        this.form.reset();
        this.loadTablaData();
        if (nextClose) {
          this.showAlert("Carrera creada correctamente", "success")
          this.gridView();
        }
      });
    } else {
      this.showAlert("Complete todos los campos de forma valida", "error")
    }
  }
  updateDataService(): void {
    console.log("Actualizar Teacher desde PUT")
    if (this.form.valid) {
      const datos = this.form.value;
        this.crudService.updateRecord({"university_id": this.university_id, tablename: "career", "params": datos as any}).subscribe((data) => {
        console.log('Respuesta del servidor:', data);
        this.form.reset();
        this.loadTablaData();
        this.showAlert("Carrera actualizada correctamente", "success")
        this.gridView();
      });
    } else {
      this.showAlert("Complete todos los campos de forma valida", "error")
    }    
  }
  deleteDataService(): void {
    console.log("DELETE Career desde PUT")
    let datos = this.getSelectedIds()
    this.crudService.deleteRecord({"university_id": this.university_id, tablename: "career", "params": {"id":datos.toString()} as any}).subscribe((data) => {
      console.log('Respuesta del servidor:', data);
      this.form.reset();
      this.loadTablaData();
      this.showAlert("Carrera eliminada correctamente", "success")
      this.gridView();
    });   
  }  
  fillEditForm(): void {
    const selectedRow = this.selectedRows[0];
    this.form.patchValue({
      id: selectedRow.id,
      identifier: selectedRow.identifier,
      name: selectedRow.name
    });
  }    
  changeSelectedRows(selectedRows: any[]): void {
    console.log("DESDE STUDEN", selectedRows)
    this.selectedRows = selectedRows;
    if (selectedRows.length === 1) {
      this.gridEditView();
    } else if (selectedRows.length > 1) {
      this.deleteView();
    } else {
      this.gridView();
    }
  }
  gridEditView(): void {
    this.tituloDeLaVentana = 'Carreras';
    this.statusView = 'grid';
    this.listaDeBotones = [
      { texto: 'Editar Carrera', onClick: () => this.editCareer() },
      { texto: 'Eliminar Carrera', onClick: () => this.deleteCareers() },
    ];
  }
  deleteView(): void {
    this.tituloDeLaVentana = 'Carreras';
    this.statusView = 'grid';
    this.listaDeBotones = [
      { texto: 'Eliminar Carrera', onClick: () => this.deleteCareers() },
    ];    
  }
  gridView(): void {
    this.form.reset();
    this.selectedRows = [];
    this.tituloDeLaVentana = 'Carreras';
    this.statusView = 'grid';
    this.listaDeBotones = [
      { texto: 'Nueva Carrera +', onClick: () => this.createCareer() },
    ];
  }
  formView(): void {
    this.tituloDeLaVentana = 'Nueva Carrera';
    this.statusView = 'form';
    this.listaDeBotones = [
      { texto: 'Guardar y volver a la lista', onClick: () => this.onSubmitAndBack() },
      { texto: 'Guardar y Crear nuevo', onClick: () => this.onSubmit(false) },
      { texto: '✕', onClick: () => this.gridView(), class: "btn-close" },
    ];
  }
  editView(): void {
    this.tituloDeLaVentana = 'Actualizar Carrera';
    this.statusView = 'form';
    this.listaDeBotones = [
      { texto: 'Guardar Cambios', onClick: () => this.updateDataService() },
      { texto: '✕', onClick: () => this.gridView(), class: "btn-close" },
    ];
  }
  onSubmitAndBack(): void {
    this.onSubmit(true);
  }
  createCareer(): void {
    this.formView();
  }
  editCareer(): void {
    console.log("editar Carrera")
    this.fillEditForm();
    this.editView();
  }
  deleteCareers(): void {
      // Pregunta al usuario si realmente desea eliminar las carreras
    const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar estos elementos?');
    // Si el usuario confirma, procede con la eliminación
    if (confirmDelete) {
      this.deleteDataService();
    }
  }
  getSelectedIds(): any[] {
    return this.selectedRows.map((row) => row.id);
  }
  getUniversityId(): number {
    if (localStorage.getItem('user') != null) {
      let JSONUser = JSON.parse(localStorage.getItem('user')??"{}");
      let user = JSONUser.user;
      return user.university_id;
    } else {
      return 0;
    }
  }  
  showAlert(message:any, type: any) {
    this.messageService.sendMessage({
      text: message,
      type: type,
      duration: 5000 
    });
  }  
}
